import BaseApi, { dangerousAxiosInstanceUseOnlyIfNeeded } from '@lumapps/base-api';

/** Root v1 API without prefix */
export const v1RootApi = new BaseApi({
    version: BaseApi.versions.v1,
    baseURL: '/',
});

/** v1 Media API */
export const v1MediaApi = new BaseApi({
    version: BaseApi.versions.v1,
    path: 'media',
});

/**
 * Fetches a direct upload link and upload the given file.
 * See https://github.com/lumapps/lumapps-back/blob/458db0aae449369a3279e75c46d4520eb516e30e/app/server/file/file_handler.py#L224
 * @deprecated We should no longer upload medias using this API, please use the uploadMedias method.
 * @param file The file to upload
 */
export const legacyDirectUpload = async (file: File) => {
    const uploadUrlResponse = await v1RootApi.get('upload', { params: { success: '/upload' } });

    const formData = new FormData();
    formData.append('file', file);

    return v1RootApi.post(uploadUrlResponse.data.uploadUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

/**
 * Re-Upload a v1 media to update it without changing its permalink
 */
export async function legacyFileReUpload(mediaId: string, file: File) {
    // Get the re-upload URL
    const { data } = await v1MediaApi.post<{ mediaId: string; headers: Record<string, string>; uploadUrl: string }>(
        `${mediaId}/reupload`,
        { fileName: file.name },
    );

    // Re-upload
    await dangerousAxiosInstanceUseOnlyIfNeeded.put(data.uploadUrl, file, {
        headers: { ...data.headers, 'Content-Type': file.type },
    });

    return data;
}
